const jhscomputingQuestions = [
  {
  question: "Which of the following is NOT an input device?",
  options: ["Keyboard", "Mouse", "Scanner", "Monitor"],
  answer: "Monitor"
},
{
  question: "Ama uses a device to type her homework on the computer. Which device is she using?",
  options: ["Mouse", "Keyboard", "Monitor", "Printer"],
  answer: "Keyboard"
},
{
  question: "Which of the following best describes the function of the CPU?",
  options: [
    "Stores files permanently",
    "Processes instructions and data",
    "Displays information on screen",
    "Connects the computer to the internet"
  ],
  answer: "Processes instructions and data"
},
{
  question: "The main screen that shows what you are doing on a computer is called the:",
  options: ["CPU", "Keyboard", "Monitor", "Mouse"],
  answer: "Monitor"
},
{
  question: "Which of the following stores data temporarily while the computer is in use?",
  options: ["ROM", "Hard disk", "RAM", "Flash drive"],
  answer: "RAM"
},
{
  question: "Which of the following is an example of an output device?",
  options: ["Keyboard", "Mouse", "Speaker", "Scanner"],
  answer: "Speaker"
},
{
  question: "Kofi prints his assignment using a computer. Which device is he using?",
  options: ["Scanner", "Printer", "Monitor", "CPU"],
  answer: "Printer"
},
{
  question: "Which of the following best explains hardware?",
  options: [
    "Programs installed on a computer",
    "Parts of a computer you can see and touch",
    "Internet services",
    "Computer instructions only"
  ],
  answer: "Parts of a computer you can see and touch"
},
{
  question: "Which of the following is system software?",
  options: ["MS Word", "Paint", "Windows", "Excel"],
  answer: "Windows"
},
{
  question: "The software that controls how the computer works is called:",
  options: ["Application software", "Operating system", "Browser", "Antivirus"],
  answer: "Operating system"
},
{
  question: "Which of the following is used to point and select items on the screen?",
  options: ["Keyboard", "Mouse", "Monitor", "Printer"],
  answer: "Mouse"
},
{
  question: "Which of the following is a storage device?",
  options: ["Keyboard", "Flash drive", "Monitor", "Speaker"],
  answer: "Flash drive"
},
{
  question: "Data can best be described as:",
  options: [
    "Processed information",
    "Raw facts and figures",
    "Computer programs",
    "Internet signals"
  ],
  answer: "Raw facts and figures"
},
{
  question: "When data is processed, it becomes:",
  options: ["Programs", "Hardware", "Information", "Memory"],
  answer: "Information"
},
{
  question: "Which of the following is the correct meaning of ICT?",
  options: [
    "Information and Communication Technology",
    "Internet and Computer Training",
    "Internal Computer Tools",
    "Information Control Technology"
  ],
  answer: "Information and Communication Technology"
},
{
  question: "Which of the following is a correct computer lab practice?",
  options: [
    "Eating while using the computer",
    "Running in the lab",
    "Keeping the lab clean and quiet",
    "Touching screens with sharp objects"
  ],
  answer: "Keeping the lab clean and quiet"
},
{
  question: "Which of the following actions can damage a computer?",
  options: [
    "Using a stabilizer",
    "Keeping it clean",
    "Exposing it to dust and heat",
    "Shutting it down properly"
  ],
  answer: "Exposing it to dust and heat"
},
{
  question: "Before switching off a computer, you should:",
  options: [
    "Pull out the plug",
    "Press the monitor button",
    "Use the shutdown option",
    "Close your eyes"
  ],
  answer: "Use the shutdown option"
},
{
  question: "Which of the following keys is used to remove characters to the left?",
  options: ["Delete", "Enter", "Backspace", "Shift"],
  answer: "Backspace"
},
{
  question: "Which of the following best describes a computer?",
  options: [
    "A device used only for typing",
    "An electronic device that processes data",
    "A machine used for printing only",
    "A tool for playing games only"
  ],
  answer: "An electronic device that processes data"
},
{
  question: "Which of the following is used to browse the internet?",
  options: ["Calculator", "Browser", "Keyboard", "Speaker"],
  answer: "Browser"
},
{
  question: "Which of the following is an example of a web browser?",
  options: ["Windows", "Google Chrome", "MS Word", "Excel"],
  answer: "Google Chrome"
},
{
  question: "The internet can best be described as:",
  options: [
    "A single computer",
    "A network of computers worldwide",
    "A storage device",
    "A type of software"
  ],
  answer: "A network of computers worldwide"
},
{
  question: "Which of the following is used to send messages electronically?",
  options: ["Scanner", "Email", "Printer", "Monitor"],
  answer: "Email"
},
{
  question: "Ama wants to send a message quickly to her friend online. Which is the best option?",
  options: ["Printing", "Email", "Typing on paper", "Drawing"],
  answer: "Email"
},
{
  question: "Which of the following is NOT a function of an operating system?",
  options: [
    "Managing files",
    "Controlling hardware",
    "Running applications",
    "Cooking food"
  ],
  answer: "Cooking food"
},
{
  question: "Which of the following is an example of an operating system?",
  options: ["Android", "MS Word", "Paint", "Calculator"],
  answer: "Android"
},
{
  question: "Which of the following helps organize files on a computer?",
  options: ["Folder", "Keyboard", "Mouse", "Monitor"],
  answer: "Folder"
},
{
  question: "A student saves his work in a specific location for easy access. What is this called?",
  options: ["Printing", "Saving in a folder", "Deleting", "Typing"],
  answer: "Saving in a folder"
},
{
  question: "Which of the following is used to open files and programs?",
  options: ["Double-click", "Typing", "Printing", "Scanning"],
  answer: "Double-click"
},
{
  question: "Which of the following is used to select multiple items?",
  options: ["Shift key", "Enter key", "Space bar", "Caps Lock"],
  answer: "Shift key"
},
{
  question: "Which of the following is used to move the cursor on the screen?",
  options: ["Mouse", "Printer", "Speaker", "Flash drive"],
  answer: "Mouse"
},
{
  question: "A student deletes a file accidentally. Where can it be found temporarily?",
  options: ["Recycle Bin", "Desktop", "Monitor", "Browser"],
  answer: "Recycle Bin"
},
{
  question: "Which of the following is used to permanently remove files?",
  options: ["Save", "Delete", "Print", "Open"],
  answer: "Delete"
},
{
  question: "Which of the following best explains a file?",
  options: [
    "A storage device",
    "A collection of data stored on a computer",
    "A computer program",
    "An input device"
  ],
  answer: "A collection of data stored on a computer"
},
{
  question: "Which of the following is a correct internet safety practice?",
  options: [
    "Sharing passwords with friends",
    "Clicking unknown links",
    "Keeping personal information private",
    "Ignoring security warnings"
  ],
  answer: "Keeping personal information private"
},
{
  question: "Which of the following can harm a computer system?",
  options: [
    "Antivirus software",
    "Computer virus",
    "Backup system",
    "Firewall"
  ],
  answer: "Computer virus"
},
{
  question: "Which of the following protects a computer from harmful software?",
  options: ["Antivirus", "Keyboard", "Mouse", "Monitor"],
  answer: "Antivirus"
},
{
  question: "Which of the following is used to search for information on the internet?",
  options: ["Search engine", "Printer", "Speaker", "Scanner"],
  answer: "Search engine"
},
{
  question: "Which of the following is an example of a search engine?",
  options: ["Google", "Windows", "Excel", "Paint"],
  answer: "Google"
},
{
  question: "Which of the following is used to type documents on a computer?",
  options: ["MS Word", "Paint", "Calculator", "Browser"],
  answer: "MS Word"
},
{
  question: "Which of the following is an example of word processing software?",
  options: ["Excel", "PowerPoint", "MS Word", "Chrome"],
  answer: "MS Word"
},
{
  question: "Ama wants to write and edit a letter on the computer. Which application should she use?",
  options: ["Paint", "MS Word", "Calculator", "Media Player"],
  answer: "MS Word"
},
{
  question: "Which of the following is used to make text darker and thicker?",
  options: ["Italic", "Underline", "Bold", "Font size"],
  answer: "Bold"
},
{
  question: "Which of the following is used to slant text?",
  options: ["Bold", "Italic", "Underline", "Align"],
  answer: "Italic"
},
{
  question: "Which of the following is used to draw a line under text?",
  options: ["Bold", "Italic", "Underline", "Font"],
  answer: "Underline"
},
{
  question: "Which of the following changes the size of text?",
  options: ["Font size", "Font color", "Alignment", "Spacing"],
  answer: "Font size"
},
{
  question: "Which of the following is used to change the style of text?",
  options: ["Font", "Print", "Save", "Open"],
  answer: "Font"
},
{
  question: "Which alignment places text evenly on both left and right margins?",
  options: ["Left", "Right", "Center", "Justify"],
  answer: "Justify"
},
{
  question: "Which alignment places text in the middle of the page?",
  options: ["Left", "Right", "Center", "Justify"],
  answer: "Center"
},
{
  question: "A student wants all text to start from the left side. Which alignment should be used?",
  options: ["Right", "Center", "Justify", "Left"],
  answer: "Left"
},
{
  question: "Which of the following is used to save a document?",
  options: ["Open", "Print", "Save", "Delete"],
  answer: "Save"
},
{
  question: "Which of the following is used to open an existing document?",
  options: ["Save", "Print", "Open", "Close"],
  answer: "Open"
},
{
  question: "Which of the following is used to produce a hard copy of a document?",
  options: ["Save", "Print", "Open", "Edit"],
  answer: "Print"
},
{
  question: "A student removes unwanted text from a document. What action is this?",
  options: ["Saving", "Editing", "Printing", "Formatting"],
  answer: "Editing"
},
{
  question: "Which of the following is used to copy text?",
  options: ["Cut", "Copy", "Paste", "Delete"],
  answer: "Copy"
},
{
  question: "Which of the following is used to move text from one place to another?",
  options: ["Copy", "Paste", "Cut", "Save"],
  answer: "Cut"
},
{
  question: "Which of the following is used to insert copied text?",
  options: ["Paste", "Cut", "Delete", "Open"],
  answer: "Paste"
},
{
  question: "A student wants to duplicate a paragraph without removing the original. Which action should be used?",
  options: ["Cut", "Delete", "Copy", "Print"],
  answer: "Copy"
},
{
  question: "Which of the following best describes formatting?",
  options: [
    "Deleting text",
    "Changing the appearance of text",
    "Saving documents",
    "Printing documents"
  ],
  answer: "Changing the appearance of text"
},
{
  question: "Which of the following best describes information?",
  options: [
    "Raw facts",
    "Unprocessed data",
    "Processed data that is meaningful",
    "Computer hardware"
  ],
  answer: "Processed data that is meaningful"
},
{
  question: "Which of the following converts data into information?",
  options: ["Processing", "Typing", "Printing", "Saving"],
  answer: "Processing"
},
{
  question: "Which of the following is an example of data?",
  options: [
    "A completed report",
    "Marks scored by students",
    "A summary of results",
    "A printed document"
  ],
  answer: "Marks scored by students"
},
{
  question: "Which of the following is a storage device?",
  options: ["Keyboard", "Flash drive", "Monitor", "Mouse"],
  answer: "Flash drive"
},
{
  question: "Which of the following stores data permanently?",
  options: ["RAM", "Cache", "Hard disk", "Register"],
  answer: "Hard disk"
},
{
  question: "Which of the following loses its content when power is turned off?",
  options: ["ROM", "Hard disk", "RAM", "Flash drive"],
  answer: "RAM"
},
{
  question: "Which of the following is non-volatile memory?",
  options: ["RAM", "Cache", "ROM", "Register"],
  answer: "ROM"
},
{
  question: "Which of the following is an example of secondary storage?",
  options: ["RAM", "ROM", "Hard disk", "CPU"],
  answer: "Hard disk"
},
{
  question: "Which of the following is used to store data externally?",
  options: ["Flash drive", "CPU", "Monitor", "Keyboard"],
  answer: "Flash drive"
},
{
  question: "A student saves files on a device that can be carried easily. What device is this?",
  options: ["Hard disk", "Flash drive", "RAM", "ROM"],
  answer: "Flash drive"
},
{
  question: "Which of the following is the smallest unit of data?",
  options: ["Byte", "Bit", "Kilobyte", "Megabyte"],
  answer: "Bit"
},
{
  question: "Which of the following consists of 8 bits?",
  options: ["Byte", "Kilobyte", "Megabyte", "Gigabyte"],
  answer: "Byte"
},
{
  question: "Which of the following is larger than a megabyte?",
  options: ["Kilobyte", "Byte", "Gigabyte", "Bit"],
  answer: "Gigabyte"
},
{
  question: "Which of the following is an example of a personal computer?",
  options: ["Supercomputer", "Desktop", "Mainframe", "Server"],
  answer: "Desktop"
},
{
  question: "Which of the following computers is the most powerful?",
  options: ["Laptop", "Desktop", "Supercomputer", "Tablet"],
  answer: "Supercomputer"
},
{
  question: "Which of the following is a portable computer?",
  options: ["Desktop", "Mainframe", "Laptop", "Server"],
  answer: "Laptop"
},
{
  question: "A student uses a tablet to read and browse. What type of computer is this?",
  options: ["Desktop", "Tablet", "Mainframe", "Supercomputer"],
  answer: "Tablet"
},
{
  question: "Which of the following best describes a server?",
  options: [
    "A device for typing",
    "A computer that provides services to other computers",
    "A device for printing",
    "A storage device only"
  ],
  answer: "A computer that provides services to other computers"
},
{
  question: "Which of the following best explains data storage?",
  options: [
    "Displaying information",
    "Keeping data for future use",
    "Processing data",
    "Deleting files"
  ],
  answer: "Keeping data for future use"
},
{
  question: "Which of the following is used to back up data?",
  options: ["Flash drive", "Keyboard", "Mouse", "Monitor"],
  answer: "Flash drive"
},
{
  question: "Which of the following best explains the role of an operating system?",
  options: [
    "Typing documents",
    "Managing computer resources and operations",
    "Printing files",
    "Browsing the internet"
  ],
  answer: "Managing computer resources and operations"
},
{
  question: "Which of the following allows the user to interact with the computer?",
  options: ["Hardware", "Operating system", "Printer", "Scanner"],
  answer: "Operating system"
},
{
  question: "Which of the following is an example of a mobile operating system?",
  options: ["Windows", "Android", "Linux", "macOS"],
  answer: "Android"
},
{
  question: "Which of the following is NOT an operating system?",
  options: ["Windows", "Linux", "Excel", "Android"],
  answer: "Excel"
},
{
  question: "Which of the following is used to organize files and folders?",
  options: ["File manager", "Browser", "Printer", "Scanner"],
  answer: "File manager"
},
{
  question: "A student creates a new folder to store files. What is this action called?",
  options: ["Deleting", "Creating", "Printing", "Editing"],
  answer: "Creating"
},
{
  question: "Which of the following is used to rename a file?",
  options: ["Edit name", "Rename", "Open", "Print"],
  answer: "Rename"
},
{
  question: "Which of the following action removes a file from one location to another permanently?",
  options: ["Copy", "Move", "Paste", "Save"],
  answer: "Move"
},
{
  question: "Which of the following allows you to make a duplicate of a file?",
  options: ["Delete", "Move", "Copy", "Rename"],
  answer: "Copy"
},
{
  question: "A student wants to protect his files from loss. What should he do?",
  options: [
    "Delete files",
    "Ignore files",
    "Back up files",
    "Rename files"
  ],
  answer: "Back up files"
},
{
  question: "Which of the following is a threat to computer security?",
  options: ["Antivirus", "Firewall", "Virus", "Backup"],
  answer: "Virus"
},
{
  question: "Which of the following is used to protect data from unauthorized access?",
  options: ["Password", "Mouse", "Printer", "Monitor"],
  answer: "Password"
},
{
  question: "Which of the following is a strong password?",
  options: ["12345", "password", "abc123", "A7@kL9!"],
  answer: "A7@kL9!"
},
{
  question: "Which of the following is an example of malware?",
  options: ["Software", "Virus", "Hardware", "Folder"],
  answer: "Virus"
},
{
  question: "Which of the following best explains a firewall?",
  options: [
    "A device for printing",
    "A system that blocks unauthorized access",
    "A storage device",
    "A type of keyboard"
  ],
  answer: "A system that blocks unauthorized access"
},
{
  question: "A student downloads files from unknown websites and gets a virus. What is the mistake?",
  options: [
    "Using a browser",
    "Downloading unsafe files",
    "Typing documents",
    "Saving files"
  ],
  answer: "Downloading unsafe files"
},
{
  question: "Which of the following is a safe internet practice?",
  options: [
    "Sharing personal details online",
    "Clicking suspicious links",
    "Using strong passwords",
    "Ignoring warnings"
  ],
  answer: "Using strong passwords"
},
{
  question: "Which of the following is used to recover lost data?",
  options: ["Backup", "Delete", "Print", "Rename"],
  answer: "Backup"
},
{
  question: "Which of the following best explains file management?",
  options: [
    "Deleting files only",
    "Organizing, storing, and retrieving files",
    "Typing documents",
    "Printing files"
  ],
  answer: "Organizing, storing, and retrieving files"
},
{
  question: "Which of the following is the best way to shut down a computer?",
  options: [
    "Pull the plug",
    "Press the power button randomly",
    "Use the shutdown option",
    "Close the monitor"
  ],
  answer: "Use the shutdown option"
},
{
  question: "Which of the following best describes a computer network?",
  options: [
    "A single computer system",
    "A group of connected computers",
    "A storage device",
    "A type of software"
  ],
  answer: "A group of connected computers"
},
{
  question: "Which of the following is a type of network?",
  options: ["LAN", "CPU", "RAM", "ROM"],
  answer: "LAN"
},
{
  question: "A network that covers a small area such as a school is called:",
  options: ["WAN", "LAN", "MAN", "Internet"],
  answer: "LAN"
},
{
  question: "Which of the following covers a large geographical area?",
  options: ["LAN", "WAN", "PAN", "USB"],
  answer: "WAN"
},
{
  question: "Which of the following is the largest network in the world?",
  options: ["LAN", "WAN", "Internet", "MAN"],
  answer: "Internet"
},
{
  question: "Which of the following is used to connect computers in a network?",
  options: ["Router", "Printer", "Keyboard", "Monitor"],
  answer: "Router"
},
{
  question: "Which of the following directs data between networks?",
  options: ["Switch", "Router", "Mouse", "Speaker"],
  answer: "Router"
},
{
  question: "Which of the following connects devices within the same network?",
  options: ["Router", "Switch", "Printer", "Scanner"],
  answer: "Switch"
},
{
  question: "Which of the following converts digital signals to analog signals for internet use?",
  options: ["Router", "Modem", "Switch", "CPU"],
  answer: "Modem"
},
{
  question: "Which of the following is used for communication over long distances?",
  options: ["Telephone", "Printer", "Keyboard", "Monitor"],
  answer: "Telephone"
},
{
  question: "Which of the following is a modern communication tool?",
  options: ["Email", "Chalkboard", "Book", "Pen"],
  answer: "Email"
},
{
  question: "Ama uses WhatsApp to chat with her friend. What type of communication is this?",
  options: ["Manual", "Digital", "Printed", "Written"],
  answer: "Digital"
},
{
  question: "Which of the following is an advantage of ICT?",
  options: [
    "Slow communication",
    "Limited access to information",
    "Fast communication",
    "Reduced efficiency"
  ],
  answer: "Fast communication"
},
{
  question: "Which of the following is a disadvantage of ICT?",
  options: [
    "Fast communication",
    "Easy access to information",
    "Cybercrime",
    "Improved education"
  ],
  answer: "Cybercrime"
},
{
  question: "Which of the following is an example of ICT use in education?",
  options: [
    "Using chalk only",
    "Typing notes on a computer",
    "Writing on paper only",
    "Ignoring technology"
  ],
  answer: "Typing notes on a computer"
},
{
  question: "Which of the following is an example of ICT use in business?",
  options: [
    "Sending emails to clients",
    "Writing letters by hand only",
    "Ignoring customers",
    "Avoiding computers"
  ],
  answer: "Sending emails to clients"
},
{
  question: "Which of the following is an example of ICT use in healthcare?",
  options: [
    "Using paper only",
    "Storing patient records electronically",
    "Ignoring data",
    "Avoiding technology"
  ],
  answer: "Storing patient records electronically"
},
{
  question: "Which of the following is an example of ICT use in banking?",
  options: [
    "Manual calculations only",
    "Online banking",
    "Writing notes only",
    "Ignoring customers"
  ],
  answer: "Online banking"
},
{
  question: "Which of the following is an example of ICT in entertainment?",
  options: [
    "Watching movies online",
    "Reading books only",
    "Writing letters",
    "Ignoring media"
  ],
  answer: "Watching movies online"
},
{
  question: "Which of the following best explains communication technology?",
  options: [
    "Devices used for cooking",
    "Tools used to share information",
    "Machines used for farming",
    "Equipment for construction"
  ],
  answer: "Tools used to share information"
},
{
  question: "Which of the following best describes an algorithm?",
  options: [
    "A computer device",
    "A step-by-step procedure to solve a problem",
    "A type of software",
    "A storage device"
  ],
  answer: "A step-by-step procedure to solve a problem"
},
{
  question: "Which of the following is an example of an algorithm?",
  options: [
    "Typing a document",
    "Steps to prepare tea",
    "Watching a movie",
    "Using a mouse"
  ],
  answer: "Steps to prepare tea"
},
{
  question: "Which of the following is used to represent an algorithm visually?",
  options: ["Flowchart", "Table", "Graph", "Diagram"],
  answer: "Flowchart"
},
{
  question: "Which of the following symbol represents the start or end in a flowchart?",
  options: ["Rectangle", "Oval", "Diamond", "Arrow"],
  answer: "Oval"
},
{
  question: "Which of the following symbol represents a process in a flowchart?",
  options: ["Rectangle", "Diamond", "Oval", "Circle"],
  answer: "Rectangle"
},
{
  question: "Which of the following symbol represents a decision in a flowchart?",
  options: ["Rectangle", "Oval", "Diamond", "Arrow"],
  answer: "Diamond"
},
{
  question: "Which of the following symbol shows the direction of flow in a flowchart?",
  options: ["Arrow", "Circle", "Rectangle", "Diamond"],
  answer: "Arrow"
},
{
  question: "A student follows steps to solve a problem correctly. What skill is this?",
  options: ["Typing", "Algorithmic thinking", "Printing", "Drawing"],
  answer: "Algorithmic thinking"
},
{
  question: "Which of the following is the first step in solving a problem?",
  options: [
    "Writing the answer",
    "Understanding the problem",
    "Printing results",
    "Saving files"
  ],
  answer: "Understanding the problem"
},
{
  question: "Which of the following is used to test whether a solution works?",
  options: ["Evaluation", "Typing", "Printing", "Saving"],
  answer: "Evaluation"
},
{
  question: "A student draws steps using symbols to solve a problem. What is this called?",
  options: ["Chart", "Flowchart", "Table", "Diagram"],
  answer: "Flowchart"
},
{
  question: "Which of the following best explains logical thinking?",
  options: [
    "Guessing answers",
    "Thinking step-by-step to solve problems",
    "Copying work",
    "Ignoring instructions"
  ],
  answer: "Thinking step-by-step to solve problems"
},
{
  question: "A student arranges steps in the correct order to solve a task. What is this called?",
  options: ["Sorting", "Sequencing", "Typing", "Saving"],
  answer: "Sequencing"
},
{
  question: "Which of the following is important when writing an algorithm?",
  options: [
    "Clarity and correct order",
    "Using many colours",
    "Writing quickly",
    "Ignoring steps"
  ],
  answer: "Clarity and correct order"
},
{
  question: "Which of the following is used to represent input/output in a flowchart?",
  options: ["Parallelogram", "Rectangle", "Diamond", "Oval"],
  answer: "Parallelogram"
},
{
  question: "A student writes instructions in plain language to solve a problem. What is this called?",
  options: ["Program", "Algorithm", "Flowchart", "Code"],
  answer: "Algorithm"
},
{
  question: "Which of the following best explains a decision in problem solving?",
  options: [
    "Following steps only",
    "Choosing between options",
    "Typing text",
    "Saving files"
  ],
  answer: "Choosing between options"
},
{
  question: "Which of the following is used to solve problems efficiently?",
  options: [
    "Guessing",
    "Logical thinking",
    "Ignoring steps",
    "Random actions"
  ],
  answer: "Logical thinking"
},
{
  question: "A student makes errors because steps are not followed in order. What is lacking?",
  options: [
    "Speed",
    "Sequencing",
    "Typing",
    "Printing"
  ],
  answer: "Sequencing"
},
{
  question: "Which of the following best explains problem solving in computing?",
  options: [
    "Using computers only",
    "Finding solutions using logical steps",
    "Typing documents",
    "Printing files"
  ],
  answer: "Finding solutions using logical steps"
},
{
  question: "Which of the following best describes a website?",
  options: [
    "A single document",
    "A collection of related web pages",
    "A computer program",
    "A storage device"
  ],
  answer: "A collection of related web pages"
},
{
  question: "Which of the following is a web page?",
  options: [
    "A single page on a website",
    "A computer hardware",
    "A storage device",
    "An input device"
  ],
  answer: "A single page on a website"
},
{
  question: "Which of the following is used to access websites?",
  options: ["Browser", "Printer", "Speaker", "Scanner"],
  answer: "Browser"
},
{
  question: "Which of the following is an example of a website?",
  options: ["www.google.com", "MS Word", "Excel", "Paint"],
  answer: "www.google.com"
},
{
  question: "Which of the following is used to locate a website?",
  options: ["URL", "CPU", "RAM", "ROM"],
  answer: "URL"
},
{
  question: "Which of the following best explains URL?",
  options: [
    "A storage device",
    "The address of a website",
    "A type of software",
    "A computer part"
  ],
  answer: "The address of a website"
},
{
  question: "Which of the following is a safe internet practice?",
  options: [
    "Sharing passwords",
    "Clicking unknown links",
    "Using secure websites",
    "Ignoring warnings"
  ],
  answer: "Using secure websites"
},
{
  question: "Which of the following is an example of cyberbullying?",
  options: [
    "Helping a friend online",
    "Sending hurtful messages online",
    "Sharing educational content",
    "Browsing safely"
  ],
  answer: "Sending hurtful messages online"
},
{
  question: "Which of the following best explains digital citizenship?",
  options: [
    "Using computers only",
    "Responsible use of technology",
    "Playing games only",
    "Typing documents"
  ],
  answer: "Responsible use of technology"
},
{
  question: "Which of the following is a good digital behavior?",
  options: [
    "Spreading false information",
    "Respecting others online",
    "Sharing passwords",
    "Ignoring rules"
  ],
  answer: "Respecting others online"
},
{
  question: "A student copies someone else's work online and submits it as his own. What is this called?",
  options: ["Editing", "Plagiarism", "Typing", "Saving"],
  answer: "Plagiarism"
},
{
  question: "Which of the following is used to protect personal information online?",
  options: ["Password", "Mouse", "Printer", "Monitor"],
  answer: "Password"
},
{
  question: "Which of the following is an example of a strong password practice?",
  options: [
    "Using your name",
    "Using simple numbers",
    "Using a mix of letters, numbers, and symbols",
    "Sharing passwords"
  ],
  answer: "Using a mix of letters, numbers, and symbols"
},
{
  question: "Which of the following is a risk of using the internet?",
  options: [
    "Access to information",
    "Cybercrime",
    "Fast communication",
    "Online learning"
  ],
  answer: "Cybercrime"
},
{
  question: "Which of the following best explains online privacy?",
  options: [
    "Sharing all information",
    "Protecting personal data",
    "Ignoring security",
    "Posting everything"
  ],
  answer: "Protecting personal data"
},
{
  question: "A student receives a suspicious email asking for personal details. What should he do?",
  options: [
    "Reply immediately",
    "Ignore or delete it",
    "Share with friends",
    "Click all links"
  ],
  answer: "Ignore or delete it"
},
{
  question: "Which of the following is a benefit of websites?",
  options: [
    "Limited information",
    "Easy access to information",
    "Slow communication",
    "Reduced learning"
  ],
  answer: "Easy access to information"
},
{
  question: "Which of the following is used to create web pages?",
  options: ["HTML", "CPU", "RAM", "ROM"],
  answer: "HTML"
},
{
  question: "Which of the following is a basic element of a web page?",
  options: ["Text", "CPU", "Mouse", "Printer"],
  answer: "Text"
},
{
  question: "Which of the following best explains ethics in ICT?",
  options: [
    "Ignoring rules",
    "Using technology responsibly and morally",
    "Sharing passwords",
    "Spreading false information"
  ],
  answer: "Using technology responsibly and morally"
},
{
  question: "A student uses a browser to access a website and download information. Which ICT components are involved?",
  options: [
    "Hardware only",
    "Software only",
    "Both hardware and software",
    "Storage only"
  ],
  answer: "Both hardware and software"
},
{
  question: "Which of the following best explains why folders are important in a computer system?",
  options: [
    "To increase file size",
    "To organize files for easy access",
    "To delete files permanently",
    "To print documents"
  ],
  answer: "To organize files for easy access"
},
{
  question: "A student saves a file but cannot find it later. What is the most likely problem?",
  options: [
    "The file was printed",
    "Poor file organization",
    "The computer is off",
    "The file was typed wrongly"
  ],
  answer: "Poor file organization"
},
{
  question: "Which of the following best explains why antivirus software is important?",
  options: [
    "To speed up typing",
    "To protect against harmful programs",
    "To increase storage",
    "To print files"
  ],
  answer: "To protect against harmful programs"
},
{
  question: "A user installs unknown software and the computer starts malfunctioning. What is the likely cause?",
  options: [
    "Good software",
    "Malware infection",
    "Proper installation",
    "System upgrade"
  ],
  answer: "Malware infection"
},
{
  question: "Which of the following best explains why strong passwords are necessary?",
  options: [
    "To make login slower",
    "To protect user accounts from unauthorized access",
    "To increase storage",
    "To improve typing speed"
  ],
  answer: "To protect user accounts from unauthorized access"
},
{
  question: "A student deletes a file but still sees it in the Recycle Bin. What does this mean?",
  options: [
    "The file is permanently deleted",
    "The file can still be restored",
    "The file is printed",
    "The file is copied"
  ],
  answer: "The file can still be restored"
},
{
  question: "Which of the following best explains the difference between data and information?",
  options: [
    "Data is processed, information is raw",
    "Data is raw, information is processed",
    "Both are the same",
    "Information is hardware"
  ],
  answer: "Data is raw, information is processed"
},
{
  question: "A student uses ICT tools to complete assignments faster. What is the main advantage demonstrated?",
  options: [
    "Increased cost",
    "Reduced efficiency",
    "Improved productivity",
    "Limited access"
  ],
  answer: "Improved productivity"
},
{
  question: "Which of the following best explains why ICT is important in modern society?",
  options: [
    "It reduces communication",
    "It improves access to information and communication",
    "It increases manual work",
    "It limits learning"
  ],
  answer: "It improves access to information and communication"
},
{
  question: "A student connects multiple computers in a lab for sharing resources. What is this system called?",
  options: [
    "Database",
    "Network",
    "Software",
    "Storage"
  ],
  answer: "Network"
},
{
  question: "Which of the following best explains the function of a modem?",
  options: [
    "Stores data",
    "Converts signals for communication",
    "Displays output",
    "Processes data"
  ],
  answer: "Converts signals for communication"
},
{
  question: "A user enters incorrect steps when solving a problem and gets wrong results. What is lacking?",
  options: [
    "Hardware",
    "Logical sequencing",
    "Storage",
    "Networking"
  ],
  answer: "Logical sequencing"
},
{
  question: "Which of the following best explains why algorithms must be clear and ordered?",
  options: [
    "To confuse users",
    "To ensure correct problem solving",
    "To delay results",
    "To reduce efficiency"
  ],
  answer: "To ensure correct problem solving"
},
{
  question: "A student uses ICT tools irresponsibly and causes harm online. What principle is violated?",
  options: [
    "Digital ethics",
    "Hardware usage",
    "File management",
    "Programming"
  ],
  answer: "Digital ethics"
},
{
  question: "Which of the following best explains cyber safety?",
  options: [
    "Using computers only",
    "Protecting oneself from online risks",
    "Typing quickly",
    "Printing documents"
  ],
  answer: "Protecting oneself from online risks"
},
{
  question: "A website collects personal information without permission. What issue does this raise?",
  options: [
    "Storage",
    "Privacy violation",
    "Networking",
    "Formatting"
  ],
  answer: "Privacy violation"
},
{
  question: "Which of the following best explains why backups are important?",
  options: [
    "To delete files",
    "To recover lost data",
    "To slow down computers",
    "To print documents"
  ],
  answer: "To recover lost data"
},
{
  question: "A student uses ICT tools to collaborate with others online. What is this called?",
  options: [
    "Isolation",
    "Collaboration",
    "Storage",
    "Deletion"
  ],
  answer: "Collaboration"
},
{
  question: "Which of the following best explains the role of ICT in learning?",
  options: [
    "Reducing knowledge",
    "Enhancing access to learning resources",
    "Limiting communication",
    "Increasing manual work"
  ],
  answer: "Enhancing access to learning resources"
},
{
  question: "A student uses a flash drive to transfer files between computers. Which concept does this represent?",
  options: [
    "Input device usage",
    "Data storage and transfer",
    "Processing data",
    "Output operation"
  ],
  answer: "Data storage and transfer"
},
{
  question: "Which of the following best explains why RAM is important in a computer system?",
  options: [
    "It stores data permanently",
    "It temporarily holds data being processed",
    "It displays output",
    "It connects to the internet"
  ],
  answer: "It temporarily holds data being processed"
},
{
  question: "A student installs antivirus software and updates it regularly. What is the main benefit?",
  options: [
    "Improved typing speed",
    "Protection against new threats",
    "Increased file size",
    "Better printing quality"
  ],
  answer: "Protection against new threats"
},
{
  question: "Which of the following best explains why file naming is important?",
  options: [
    "To make files larger",
    "To easily identify and retrieve files",
    "To delete files faster",
    "To increase storage"
  ],
  answer: "To easily identify and retrieve files"
},
{
  question: "A student opens multiple programs and the computer becomes slow. What is the likely cause?",
  options: [
    "Too much storage space",
    "Insufficient RAM",
    "Strong processor",
    "Good network"
  ],
  answer: "Insufficient RAM"
},
{
  question: "Which of the following best explains the role of a search engine?",
  options: [
    "Stores files",
    "Finds information on the internet",
    "Prints documents",
    "Processes data"
  ],
  answer: "Finds information on the internet"
},
{
  question: "A user connects to public Wi-Fi and enters personal details. What is the main risk?",
  options: [
    "Faster internet",
    "Data theft",
    "Better security",
    "Improved storage"
  ],
  answer: "Data theft"
},
{
  question: "Which of the following best explains why updates are important for software?",
  options: [
    "To reduce performance",
    "To fix bugs and improve security",
    "To delete files",
    "To increase errors"
  ],
  answer: "To fix bugs and improve security"
},
{
  question: "A student saves a file with a wrong name and cannot recognize it later. What principle is violated?",
  options: [
    "File storage",
    "Proper file naming",
    "Data processing",
    "Networking"
  ],
  answer: "Proper file naming"
},
{
  question: "Which of the following best explains cloud storage?",
  options: [
    "Saving files on paper",
    "Saving files online",
    "Saving files in RAM",
    "Saving files in CPU"
  ],
  answer: "Saving files online"
},
{
  question: "A student uploads assignments to an online platform. Which ICT concept is this?",
  options: [
    "Offline storage",
    "Cloud computing",
    "Printing",
    "Formatting"
  ],
  answer: "Cloud computing"
},
{
  question: "Which of the following best explains the role of input devices?",
  options: [
    "Display results",
    "Enter data into the computer",
    "Store data",
    "Process data"
  ],
  answer: "Enter data into the computer"
},
{
  question: "A student uses a microphone to record sound. What type of device is this?",
  options: [
    "Output device",
    "Storage device",
    "Input device",
    "Processing device"
  ],
  answer: "Input device"
},
{
  question: "Which of the following best explains output devices?",
  options: [
    "Devices used to input data",
    "Devices that display or produce results",
    "Devices for storage",
    "Devices for processing only"
  ],
  answer: "Devices that display or produce results"
},
{
  question: "A student uses a projector to display information. What type of device is this?",
  options: [
    "Input device",
    "Output device",
    "Storage device",
    "Processing device"
  ],
  answer: "Output device"
},
{
  question: "Which of the following best explains multitasking in computing?",
  options: [
    "Running one program at a time",
    "Running multiple programs at once",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Running multiple programs at once"
},
{
  question: "A student switches between different applications while working. What is this called?",
  options: [
    "Formatting",
    "Multitasking",
    "Saving",
    "Printing"
  ],
  answer: "Multitasking"
},
{
  question: "Which of the following best explains digital communication?",
  options: [
    "Manual writing",
    "Sharing information using electronic devices",
    "Printing documents",
    "Typing only"
  ],
  answer: "Sharing information using electronic devices"
},
{
  question: "A student participates in an online class. What is this an example of?",
  options: [
    "Offline learning",
    "Digital communication",
    "Printing",
    "Storage"
  ],
  answer: "Digital communication"
},
{
  question: "Which of the following best explains the importance of ICT in business?",
  options: [
    "Slows communication",
    "Improves efficiency and communication",
    "Reduces productivity",
    "Limits access"
  ],
  answer: "Improves efficiency and communication"
},
{
  question: "A student saves files on both a hard disk and a flash drive. What is the main advantage?",
  options: [
    "Increases file size",
    "Provides data backup",
    "Reduces storage",
    "Slows the computer"
  ],
  answer: "Provides data backup"
},
{
  question: "Which of the following best explains why data validation is important?",
  options: [
    "To increase errors",
    "To ensure data accuracy",
    "To reduce storage",
    "To slow processing"
  ],
  answer: "To ensure data accuracy"
},
{
  question: "A student enters wrong data into a system and gets incorrect results. What is the main issue?",
  options: [
    "Poor hardware",
    "Incorrect input data",
    "Strong processing",
    "Good output"
  ],
  answer: "Incorrect input data"
},
{
  question: "Which of the following best explains the relationship between hardware and software?",
  options: [
    "They work independently",
    "Software controls hardware to perform tasks",
    "Hardware replaces software",
    "Software stores data only"
  ],
  answer: "Software controls hardware to perform tasks"
},
{
  question: "A student installs too many programs and the system becomes slow. What is the likely reason?",
  options: [
    "More storage available",
    "Limited system resources",
    "Better performance",
    "Strong processor"
  ],
  answer: "Limited system resources"
},
{
  question: "Which of the following best explains file compression?",
  options: [
    "Increasing file size",
    "Reducing file size to save space",
    "Deleting files",
    "Printing files"
  ],
  answer: "Reducing file size to save space"
},
{
  question: "A user compresses files before sending them online. What is the main benefit?",
  options: [
    "Slower transfer",
    "Faster file transfer",
    "Increased file size",
    "Reduced quality only"
  ],
  answer: "Faster file transfer"
},
{
  question: "Which of the following best explains data security?",
  options: [
    "Sharing data freely",
    "Protecting data from unauthorized access",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Protecting data from unauthorized access"
},
{
  question: "A student logs out of an account after use. What principle is applied?",
  options: [
    "File management",
    "Data security",
    "Programming",
    "Formatting"
  ],
  answer: "Data security"
},
{
  question: "Which of the following best explains the role of a switch in networking?",
  options: [
    "Connects networks together",
    "Connects devices within a network",
    "Stores data",
    "Processes information"
  ],
  answer: "Connects devices within a network"
},
{
  question: "A student shares files between computers using a network. What is this called?",
  options: [
    "Processing",
    "Networking",
    "Formatting",
    "Printing"
  ],
  answer: "Networking"
},
{
  question: "Which of the following best explains a website link?",
  options: [
    "A storage device",
    "A connection to another web page",
    "A hardware component",
    "A software program"
  ],
  answer: "A connection to another web page"
},
{
  question: "A student clicks on a hyperlink and moves to another page. What action is this?",
  options: [
    "Saving",
    "Navigating",
    "Printing",
    "Deleting"
  ],
  answer: "Navigating"
},
{
  question: "Which of the following best explains multitasking efficiency?",
  options: [
    "Running many tasks poorly",
    "Managing multiple tasks effectively",
    "Deleting programs",
    "Printing documents"
  ],
  answer: "Managing multiple tasks effectively"
},
{
  question: "A student uses a computer to edit, save, and print documents. What is this an example of?",
  options: [
    "Single tasking",
    "Multitasking",
    "Storage",
    "Networking"
  ],
  answer: "Multitasking"
},
{
  question: "Which of the following best explains ICT ethics?",
  options: [
    "Using technology irresponsibly",
    "Following rules and moral guidelines in ICT use",
    "Ignoring privacy",
    "Sharing passwords"
  ],
  answer: "Following rules and moral guidelines in ICT use"
},
{
  question: "A student respects others online and avoids harmful actions. What is demonstrated?",
  options: [
    "Cybercrime",
    "Digital ethics",
    "Hacking",
    "Malware"
  ],
  answer: "Digital ethics"
},
{
  question: "Which of the following best explains the importance of backups in computing?",
  options: [
    "To delete files",
    "To recover data in case of loss",
    "To increase errors",
    "To slow systems"
  ],
  answer: "To recover data in case of loss"
},
{
  question: "A student loses files due to system failure but restores them from backup. What is demonstrated?",
  options: [
    "File deletion",
    "Data recovery",
    "Formatting",
    "Networking"
  ],
  answer: "Data recovery"
},
{
  question: "Which of the following best explains productivity in ICT?",
  options: [
    "Working slowly",
    "Completing tasks efficiently using technology",
    "Avoiding computers",
    "Reducing output"
  ],
  answer: "Completing tasks efficiently using technology"
},
{
  question: "A student saves work regularly while typing. What is the main benefit?",
  options: [
    "Increases typing speed",
    "Prevents loss of data",
    "Improves formatting",
    "Reduces file size"
  ],
  answer: "Prevents loss of data"
},
{
  question: "Which of the following best explains why auto-save features are important?",
  options: [
    "To increase file size",
    "To automatically save work at intervals",
    "To delete files",
    "To slow down the system"
  ],
  answer: "To automatically save work at intervals"
},
{
  question: "A student opens a suspicious file attachment and the system gets infected. What is the cause?",
  options: [
    "Proper usage",
    "Malware attack",
    "System update",
    "File compression"
  ],
  answer: "Malware attack"
},
{
  question: "Which of the following best explains phishing?",
  options: [
    "Fishing in water",
    "Attempt to steal personal information online",
    "Sending emails safely",
    "Browsing websites"
  ],
  answer: "Attempt to steal personal information online"
},
{
  question: "A student receives a fake message requesting passwords. What type of threat is this?",
  options: [
    "Backup",
    "Phishing",
    "Formatting",
    "Printing"
  ],
  answer: "Phishing"
},
{
  question: "Which of the following best explains cloud computing?",
  options: [
    "Using only local storage",
    "Using internet-based services for storage and processing",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Using internet-based services for storage and processing"
},
{
  question: "A student accesses files from different devices using the internet. What is this called?",
  options: [
    "Offline storage",
    "Cloud computing",
    "File deletion",
    "Formatting"
  ],
  answer: "Cloud computing"
},
{
  question: "Which of the following best explains data redundancy?",
  options: [
    "Loss of data",
    "Duplication of data",
    "Processing data",
    "Deleting data"
  ],
  answer: "Duplication of data"
},
{
  question: "A student saves the same file in multiple locations unnecessarily. What issue may arise?",
  options: [
    "Improved speed",
    "Data redundancy",
    "Better organization",
    "Faster processing"
  ],
  answer: "Data redundancy"
},
{
  question: "Which of the following best explains the role of a database?",
  options: [
    "To display images",
    "To store and manage data systematically",
    "To print documents",
    "To browse the internet"
  ],
  answer: "To store and manage data systematically"
},
{
  question: "A school keeps student records in an organized system for easy retrieval. What is this called?",
  options: [
    "File deletion",
    "Database system",
    "Printing system",
    "Formatting system"
  ],
  answer: "Database system"
},
{
  question: "Which of the following best explains data sharing?",
  options: [
    "Keeping data private",
    "Making data available to others",
    "Deleting data",
    "Printing data"
  ],
  answer: "Making data available to others"
},
{
  question: "A student sends files to classmates through email. What concept is this?",
  options: [
    "Data sharing",
    "Data deletion",
    "Data formatting",
    "Data storage"
  ],
  answer: "Data sharing"
},
{
  question: "Which of the following best explains user interface?",
  options: [
    "Hardware components only",
    "How users interact with a computer system",
    "Storage system",
    "Network device"
  ],
  answer: "How users interact with a computer system"
},
{
  question: "A student clicks icons and uses menus to operate a computer. What is this called?",
  options: [
    "Programming",
    "User interface interaction",
    "Data storage",
    "Networking"
  ],
  answer: "User interface interaction"
},
{
  question: "Which of the following best explains file extension?",
  options: [
    "Part of a file name that indicates file type",
    "Storage device",
    "Hardware component",
    "Network type"
  ],
  answer: "Part of a file name that indicates file type"
},
{
  question: "A file named 'report.docx' has 'docx' as what?",
  options: [
    "File name",
    "File extension",
    "Folder name",
    "Storage device"
  ],
  answer: "File extension"
},
{
  question: "Which of the following best explains system upgrade?",
  options: [
    "Reducing performance",
    "Improving system capabilities",
    "Deleting programs",
    "Printing files"
  ],
  answer: "Improving system capabilities"
},
{
  question: "A student installs a newer version of software for better performance. What is this called?",
  options: [
    "Formatting",
    "System upgrade",
    "Data deletion",
    "File management"
  ],
  answer: "System upgrade"
},
{
  question: "Which of the following best explains troubleshooting?",
  options: [
    "Creating problems",
    "Identifying and solving system issues",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Identifying and solving system issues"
},
{
  question: "A student saves a document but the power goes off before saving again. What determines whether the latest changes are kept?",
  options: [
    "Printer settings",
    "Last saved version",
    "File name",
    "Internet connection"
  ],
  answer: "Last saved version"
},
{
  question: "Which of the following best explains why version control is important in file management?",
  options: [
    "To increase file size",
    "To track changes and avoid loss of work",
    "To delete files faster",
    "To print documents"
  ],
  answer: "To track changes and avoid loss of work"
},
{
  question: "A student organizes files into folders by subject. What is the main benefit?",
  options: [
    "Increases file size",
    "Improves file retrieval",
    "Deletes files automatically",
    "Slows the computer"
  ],
  answer: "Improves file retrieval"
},
{
  question: "Which of the following best explains why file paths are important?",
  options: [
    "To increase storage",
    "To show the location of files",
    "To delete files",
    "To print documents"
  ],
  answer: "To show the location of files"
},
{
  question: "A student installs software from an untrusted source and the system behaves abnormally. What is the likely issue?",
  options: [
    "Hardware failure",
    "Malware infection",
    "Good installation",
    "Proper configuration"
  ],
  answer: "Malware infection"
},
{
  question: "Which of the following best explains the importance of software licensing?",
  options: [
    "To copy software freely",
    "To ensure legal and authorized use",
    "To reduce performance",
    "To increase viruses"
  ],
  answer: "To ensure legal and authorized use"
},
{
  question: "A student shares copyrighted material without permission. What principle is violated?",
  options: [
    "File management",
    "Copyright law",
    "Networking",
    "Data storage"
  ],
  answer: "Copyright law"
},
{
  question: "Which of the following best explains bandwidth in networking?",
  options: [
    "Storage capacity",
    "Speed of data transmission",
    "Processing power",
    "File size"
  ],
  answer: "Speed of data transmission"
},
{
  question: "A slow internet connection affects video streaming quality. What factor is responsible?",
  options: [
    "CPU speed",
    "Bandwidth",
    "RAM size",
    "Storage capacity"
  ],
  answer: "Bandwidth"
},
{
  question: "Which of the following best explains latency in communication?",
  options: [
    "File size",
    "Delay in data transmission",
    "Storage speed",
    "Processing power"
  ],
  answer: "Delay in data transmission"
},
{
  question: "A student experiences delay while loading a website. What is the issue?",
  options: [
    "High storage",
    "Latency",
    "Fast processing",
    "Strong password"
  ],
  answer: "Latency"
},
{
  question: "Which of the following best explains data integrity?",
  options: [
    "Deleting data",
    "Maintaining accuracy and consistency of data",
    "Printing documents",
    "Sharing files"
  ],
  answer: "Maintaining accuracy and consistency of data"
},
{
  question: "A student modifies data incorrectly and results become unreliable. What is affected?",
  options: [
    "Storage",
    "Data integrity",
    "Networking",
    "Formatting"
  ],
  answer: "Data integrity"
},
{
  question: "Which of the following best explains encryption?",
  options: [
    "Deleting data",
    "Converting data into a secure format",
    "Printing files",
    "Storing data"
  ],
  answer: "Converting data into a secure format"
},
{
  question: "A student sends confidential information securely over the internet. What method is used?",
  options: [
    "Formatting",
    "Encryption",
    "Printing",
    "Deleting"
  ],
  answer: "Encryption"
},
{
  question: "Which of the following best explains multitasking limitations?",
  options: [
    "Unlimited performance",
    "Reduced efficiency when too many tasks run",
    "Increased speed always",
    "No effect on system"
  ],
  answer: "Reduced efficiency when too many tasks run"
},
{
  question: "A student runs many programs and the computer freezes. What is the likely cause?",
  options: [
    "Strong processor",
    "Overloading system resources",
    "Good performance",
    "Proper usage"
  ],
  answer: "Overloading system resources"
},
{
  question: "Which of the following best explains user authentication?",
  options: [
    "Deleting users",
    "Verifying user identity",
    "Printing documents",
    "Saving files"
  ],
  answer: "Verifying user identity"
},
{
  question: "A student logs in using a username and password. What process is this?",
  options: [
    "Data storage",
    "User authentication",
    "Networking",
    "Formatting"
  ],
  answer: "User authentication"
},
{
  question: "Which of the following best explains system performance?",
  options: [
    "Speed and efficiency of operations",
    "File size",
    "Storage only",
    "Printing quality"
  ],
  answer: "Speed and efficiency of operations"
},
{
  question: "A student saves a file in a wrong folder and cannot locate it. Which concept is misunderstood?",
  options: [
    "File extension",
    "File location",
    "Data processing",
    "Printing"
  ],
  answer: "File location"
},
{
  question: "Which of the following best explains directory structure?",
  options: [
    "Arrangement of files and folders",
    "Computer hardware design",
    "Internet connection",
    "Data processing method"
  ],
  answer: "Arrangement of files and folders"
},
{
  question: "A student compresses files before uploading them online. What is the main advantage?",
  options: [
    "Increases file size",
    "Reduces upload time",
    "Deletes files",
    "Improves printing"
  ],
  answer: "Reduces upload time"
},
{
  question: "Which of the following best explains the importance of updating antivirus software?",
  options: [
    "To slow down the system",
    "To detect new threats",
    "To delete files",
    "To increase storage"
  ],
  answer: "To detect new threats"
},
{
  question: "A student uses weak passwords and loses account access. What principle is violated?",
  options: [
    "File management",
    "Data security",
    "Networking",
    "Formatting"
  ],
  answer: "Data security"
},
{
  question: "Which of the following best explains two-factor authentication?",
  options: [
    "Using one password",
    "Using two methods to verify identity",
    "Saving files twice",
    "Printing twice"
  ],
  answer: "Using two methods to verify identity"
},
{
  question: "A student logs in using a password and a verification code. What security method is used?",
  options: [
    "Encryption",
    "Two-factor authentication",
    "File compression",
    "Backup"
  ],
  answer: "Two-factor authentication"
},
{
  question: "Which of the following best explains data synchronization?",
  options: [
    "Deleting data",
    "Keeping data updated across devices",
    "Printing files",
    "Formatting documents"
  ],
  answer: "Keeping data updated across devices"
},
{
  question: "A student edits a document on one device and sees the changes on another device. What is this called?",
  options: [
    "Data synchronization",
    "Data deletion",
    "File compression",
    "Printing"
  ],
  answer: "Data synchronization"
},
{
  question: "Which of the following best explains network security?",
  options: [
    "Sharing data freely",
    "Protecting network systems from threats",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Protecting network systems from threats"
},
{
  question: "A hacker gains access to a system through weak security. What is the main issue?",
  options: [
    "Strong password",
    "Poor security measures",
    "Good encryption",
    "Proper storage"
  ],
  answer: "Poor security measures"
},
{
  question: "Which of the following best explains digital footprint?",
  options: [
    "Physical footprint",
    "Record of online activities",
    "Storage device",
    "Computer hardware"
  ],
  answer: "Record of online activities"
},
{
  question: "A student posts information online and it remains available permanently. What concept is illustrated?",
  options: [
    "File storage",
    "Digital footprint",
    "Networking",
    "Formatting"
  ],
  answer: "Digital footprint"
},
{
  question: "Which of the following best explains e-learning?",
  options: [
    "Learning without technology",
    "Learning using digital platforms",
    "Printing books",
    "Writing manually"
  ],
  answer: "Learning using digital platforms"
},
{
  question: "A student attends classes online and submits assignments digitally. What is this called?",
  options: [
    "Manual learning",
    "E-learning",
    "Printing",
    "Storage"
  ],
  answer: "E-learning"
},
{
  question: "Which of the following best explains system crash?",
  options: [
    "Proper operation",
    "Sudden failure of a computer system",
    "File saving",
    "Printing"
  ],
  answer: "Sudden failure of a computer system"
},
{
  question: "A student loses unsaved work after a system crash. What is the main lesson?",
  options: [
    "Avoid saving",
    "Save work regularly",
    "Delete files",
    "Print documents"
  ],
  answer: "Save work regularly"
},
{
  question: "Which of the following best explains data recovery?",
  options: [
    "Deleting data",
    "Restoring lost or damaged data",
    "Printing files",
    "Formatting documents"
  ],
  answer: "Restoring lost or damaged data"
},
{
  question: "A student retrieves lost files after a crash using backup. What process is this?",
  options: [
    "Data deletion",
    "Data recovery",
    "Formatting",
    "Networking"
  ],
  answer: "Data recovery"
},
{
  question: "Which of the following best explains system maintenance?",
  options: [
    "Ignoring issues",
    "Regular care to keep system working properly",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Regular care to keep system working properly"
},
{
  question: "A student edits a document but forgets to save before closing it. What is the outcome?",
  options: [
    "Changes are saved automatically",
    "Changes are lost",
    "File is deleted permanently",
    "File is printed"
  ],
  answer: "Changes are lost"
},
{
  question: "Which of the following best explains why saving work frequently is important?",
  options: [
    "To increase file size",
    "To prevent loss of data",
    "To slow down the system",
    "To improve printing"
  ],
  answer: "To prevent loss of data"
},
{
  question: "A student connects to a secure website with 'https'. What does this indicate?",
  options: [
    "The site is faster",
    "The connection is secure",
    "The site is offline",
    "The file is saved"
  ],
  answer: "The connection is secure"
},
{
  question: "Which of the following best explains why secure websites are important?",
  options: [
    "To increase speed",
    "To protect user data during transmission",
    "To reduce storage",
    "To improve printing"
  ],
  answer: "To protect user data during transmission"
},
{
  question: "A student uses the same password for multiple accounts and one is hacked. What is the risk?",
  options: [
    "Improved security",
    "Multiple account compromise",
    "Faster login",
    "Better storage"
  ],
  answer: "Multiple account compromise"
},
{
  question: "Which of the following best explains why different passwords should be used?",
  options: [
    "To reduce security",
    "To protect multiple accounts",
    "To increase errors",
    "To slow login"
  ],
  answer: "To protect multiple accounts"
},
{
  question: "A student downloads a file from an unknown source and installs it. What is the likely consequence?",
  options: [
    "Improved performance",
    "Malware infection",
    "Better security",
    "Faster processing"
  ],
  answer: "Malware infection"
},
{
  question: "Which of the following best explains why software should be downloaded from trusted sources?",
  options: [
    "To increase file size",
    "To avoid malware and security risks",
    "To reduce performance",
    "To delete files"
  ],
  answer: "To avoid malware and security risks"
},
{
  question: "A student opens many browser tabs and the system slows down. What is the main reason?",
  options: [
    "Strong processor",
    "High RAM usage",
    "Good internet",
    "Proper usage"
  ],
  answer: "High RAM usage"
},
{
  question: "Which of the following best explains efficient use of system resources?",
  options: [
    "Running many programs unnecessarily",
    "Managing programs wisely",
    "Ignoring system performance",
    "Deleting all files"
  ],
  answer: "Managing programs wisely"
},
{
  question: "A student stores important files only on one device which later fails. What mistake was made?",
  options: [
    "Proper storage",
    "Lack of backup",
    "Good file naming",
    "Correct formatting"
  ],
  answer: "Lack of backup"
},
{
  question: "Which of the following best explains redundancy in backup systems?",
  options: [
    "Deleting files",
    "Keeping multiple copies for safety",
    "Printing files",
    "Formatting documents"
  ],
  answer: "Keeping multiple copies for safety"
},
{
  question: "A student accesses online resources for research. What is this an example of?",
  options: [
    "Offline storage",
    "ICT application in education",
    "File deletion",
    "Formatting"
  ],
  answer: "ICT application in education"
},
{
  question: "Which of the following best explains digital literacy?",
  options: [
    "Using computers without understanding",
    "Ability to use ICT effectively",
    "Typing only",
    "Printing documents"
  ],
  answer: "Ability to use ICT effectively"
},
{
  question: "A student shares false information online. What is the consequence?",
  options: [
    "Improved communication",
    "Spread of misinformation",
    "Better learning",
    "Increased security"
  ],
  answer: "Spread of misinformation"
},
{
  question: "Which of the following best explains responsible use of ICT?",
  options: [
    "Sharing false information",
    "Using technology ethically",
    "Ignoring privacy",
    "Hacking systems"
  ],
  answer: "Using technology ethically"
},
{
  question: "A student uses ICT tools to complete tasks quickly and accurately. What is demonstrated?",
  options: [
    "Inefficiency",
    "Productivity",
    "Storage",
    "Networking"
  ],
  answer: "Productivity"
},
{
  question: "Which of the following best explains collaboration using ICT?",
  options: [
    "Working alone",
    "Working together using digital tools",
    "Ignoring others",
    "Deleting files"
  ],
  answer: "Working together using digital tools"
},
{
  question: "A student participates in a group project using online tools. What is this called?",
  options: [
    "Isolation",
    "Digital collaboration",
    "Storage",
    "Formatting"
  ],
  answer: "Digital collaboration"
},
{
  question: "Which of the following best explains innovation in ICT?",
  options: [
    "Repeating old methods",
    "Introducing new ideas and technologies",
    "Deleting files",
    "Printing documents"
  ],
  answer: "Introducing new ideas and technologies"
},
{
  question: "A student saves a file as 'image.jpg'. What does 'jpg' represent?",
  options: [
    "File name",
    "File extension",
    "Folder name",
    "Program name"
  ],
  answer: "File extension"
},
{
  question: "Which of the following best explains file type?",
  options: [
    "The size of a file",
    "The format in which a file is stored",
    "The location of a file",
    "The name of a file"
  ],
  answer: "The format in which a file is stored"
},
{
  question: "Which of the following is an example of an image file type?",
  options: [".txt", ".jpg", ".docx", ".exe"],
  answer: ".jpg"
},
{
  question: "Which of the following is an example of a text file type?",
  options: [".jpg", ".mp3", ".txt", ".png"],
  answer: ".txt"
},
{
  question: "Which of the following is an example of an audio file type?",
  options: [".docx", ".jpg", ".mp3", ".txt"],
  answer: ".mp3"
},
{
  question: "Which of the following best explains network topology?",
  options: [
    "Type of software",
    "Arrangement of devices in a network",
    "Storage method",
    "Processing method"
  ],
  answer: "Arrangement of devices in a network"
},
{
  question: "Which of the following is a type of network topology?",
  options: ["Star", "CPU", "RAM", "ROM"],
  answer: "Star"
},
{
  question: "Which network topology connects all devices to a central point?",
  options: ["Bus", "Ring", "Star", "Mesh"],
  answer: "Star"
},
{
  question: "Which network topology connects devices in a circular form?",
  options: ["Star", "Bus", "Ring", "Tree"],
  answer: "Ring"
},
{
  question: "Which network topology uses a single central cable?",
  options: ["Star", "Ring", "Bus", "Mesh"],
  answer: "Bus"
},
{
  question: "Which of the following best explains pseudocode?",
  options: [
    "Programming language",
    "Informal way of writing program steps",
    "Computer hardware",
    "Network system"
  ],
  answer: "Informal way of writing program steps"
},
{
  question: "Which of the following is an example of pseudocode?",
  options: [
    "START ? Input number ? Display number ? END",
    "print('Hello')",
    "HTML code",
    "Binary code"
  ],
  answer: "START ? Input number ? Display number ? END"
},
{
  question: "Which of the following best explains the 'head' section of a web page?",
  options: [
    "Displays content to users",
    "Contains background information about the page",
    "Stores files",
    "Processes data"
  ],
  answer: "Contains background information about the page"
},
{
  question: "Which part of a web page contains visible content?",
  options: ["Head", "Body", "Title", "Link"],
  answer: "Body"
},
{
  question: "Which of the following best explains a web page title?",
  options: [
    "Content displayed in the browser tab",
    "Main body text",
    "Storage location",
    "Network device"
  ],
  answer: "Content displayed in the browser tab"
},
{
  question: "A student organizes a network using a central hub device. Which topology is used?",
  options: ["Ring", "Bus", "Star", "Mesh"],
  answer: "Star"
},
{
  question: "Which of the following best explains data transmission?",
  options: [
    "Storing data",
    "Sending data from one place to another",
    "Deleting data",
    "Printing data"
  ],
  answer: "Sending data from one place to another"
},
{
  question: "A student sends a file through email. What process is involved?",
  options: [
    "Data storage",
    "Data transmission",
    "Data deletion",
    "Data formatting"
  ],
  answer: "Data transmission"
},
{
  question: "Which of the following best explains system efficiency?",
  options: [
    "Slow performance",
    "Ability to perform tasks quickly and correctly",
    "Large file size",
    "Multiple errors"
  ],
  answer: "Ability to perform tasks quickly and correctly"
},
{
  question: "A student closes unused programs to improve speed. What is improved?",
  options: [
    "Storage",
    "System efficiency",
    "File size",
    "Printing"
  ],
  answer: "System efficiency"
},
{
  question: "Which of the following network topologies provides multiple paths between devices for reliability?",
  options: ["Star", "Bus", "Ring", "Mesh"],
  answer: "Mesh"
},
{
  question: "Which topology is MOST affected if the main backbone cable fails?",
  options: ["Star", "Bus", "Mesh", "Tree"],
  answer: "Bus"
},
{
  question: "Which topology can continue to function even if one connection fails?",
  options: ["Bus", "Ring", "Mesh", "Star"],
  answer: "Mesh"
},
{
  question: "In a ring topology, what happens if one device fails (without bypass)?",
  options: [
    "Nothing happens",
    "Only that device stops",
    "The whole network may be affected",
    "Network becomes faster"
  ],
  answer: "The whole network may be affected"
},
{
  question: "Which of the following is a correct pseudocode statement for input?",
  options: [
    "PRINT number",
    "INPUT number",
    "DISPLAY number",
    "SHOW number"
  ],
  answer: "INPUT number"
},
{
  question: "Which of the following is used to display output in pseudocode?",
  options: [
    "INPUT",
    "DISPLAY",
    "READ",
    "STORE"
  ],
  answer: "DISPLAY"
},
{
  question: "Which of the following is the correct sequence in pseudocode?",
  options: [
    "DISPLAY ? INPUT ? PROCESS",
    "INPUT ? PROCESS ? OUTPUT",
    "PROCESS ? INPUT ? OUTPUT",
    "OUTPUT ? PROCESS ? INPUT"
  ],
  answer: "INPUT ? PROCESS ? OUTPUT"
},
{
  question: "Which of the following is a correct example of a decision in pseudocode?",
  options: [
    "INPUT number",
    "DISPLAY result",
    "IF number > 10 THEN DISPLAY 'High'",
    "START"
  ],
  answer: "IF number > 10 THEN DISPLAY 'High'"
},
{
  question: "Which of the following is found inside the <body> tag of a web page?",
  options: [
    "Page metadata",
    "Visible content",
    "File storage",
    "Network data"
  ],
  answer: "Visible content"
},
{
  question: "Which HTML tag is used to define the title of a web page?",
  options: ["<body>", "<title>", "<head>", "<html>"],
  answer: "<title>"
},
{
  question: "Which of the following best explains metadata in a web page?",
  options: [
    "Visible text",
    "Hidden information about the page",
    "Images only",
    "Network data"
  ],
  answer: "Hidden information about the page"
},
{
  question: "Which of the following file types is used for documents?",
  options: [".mp3", ".jpg", ".docx", ".png"],
  answer: ".docx"
},
{
  question: "Which file type is commonly used for video?",
  options: [".txt", ".mp4", ".jpg", ".docx"],
  answer: ".mp4"
},
{
  question: "Which of the following is an executable file type?",
  options: [".txt", ".jpg", ".exe", ".mp3"],
  answer: ".exe"
},
{
  question: "Which of the following best explains input/output classification?",
  options: [
    "Devices that store data only",
    "Devices that either send data into or receive data from a computer",
    "Devices for networking only",
    "Devices for processing only"
  ],
  answer: "Devices that either send data into or receive data from a computer"
},
{
  question: "A touchscreen allows users to input and receive output. What type of device is it?",
  options: [
    "Input only",
    "Output only",
    "Input and output device",
    "Storage device"
  ],
  answer: "Input and output device"
},
{
  question: "Which of the following is an example of a soft copy?",
  options: [
    "Printed document",
    "Displayed screen content",
    "Notebook writing",
    "Photocopy"
  ],
  answer: "Displayed screen content"
},
{
  question: "Which of the following is an example of a hard copy?",
  options: [
    "Screen display",
    "Printed document",
    "Soft file",
    "Digital image"
  ],
  answer: "Printed document"
},
{
  question: "Which of the following best explains system reliability?",
  options: [
    "Frequent failures",
    "Ability to work without errors over time",
    "Large file size",
    "Slow processing"
  ],
  answer: "Ability to work without errors over time"
},
{
  question: "Which of the following best explains system usability?",
  options: [
    "Difficulty in use",
    "Ease of use and user friendliness",
    "Large storage",
    "Fast processing only"
  ],
  answer: "Ease of use and user friendliness"
},

  {
    question: "The final step when using a computer for the day is:",
    options: ["Restart", "Shutdown", "Refresh", "Hibernate"],
    answer: "Shutdown"
  }
];

export default jhscomputingQuestions;





